import React from 'react';
import backgroundImage from '../assets/error403.svg';
import { NavLink } from 'react-router-dom';

const ForbiddenPage = () => {
  return (
    <div className='flex flex-col md:flex-row h-screen w-full'>
      {/* Image Section */}
      <div className="relative flex items-center justify-center w-full md:w-1/2">
        <img
          src={backgroundImage}
          alt="ERROR 403"
          className=""
        />
      </div>

      {/* Text and Button Section */}
      <div className='flex flex-col my-10 md:my-0 mx-8 md:w-1/2 justify-center items-center text-[#222224]'>
        <h1 className='text-2xl md:text-4xl font-bold text-center mb-6 mt-4 md:mt-6'>We are Sorry...</h1>
        <p className='text-lg md:text-xl font-medium text-center px-4 md:px-8'>
          The page you are trying to access has restricted access.
        </p>
        <p className='text-lg md:text-xl font-medium text-center px-4 md:px-8'>
          Please return to the home page.
        </p>
        <NavLink to='/'>
          <button className='mt-8 w-24 md:w-28 flex p-2 rounded-xl border-1 border-gray-100 items-center justify-center bg-skin-button text-white font-bold gap-2 active:scale-[0.98] active:duration-75 hover:scale-[1.01] transition-all'>
            Go Back
          </button>
        </NavLink>
      </div>
    </div>
  );
};

export default ForbiddenPage;
